import { render } from "./GDQSettings.vue?vue&type=template&id=73b792c2"
import script from "./GDQSettings.vue?vue&type=script&lang=js"
export * from "./GDQSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__